import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { selectCmsControlById } from "../../../redux/slices/cmsSettingsSlice";
import { setAppEmailModalOpen } from "../../../redux/slices/appSettingsSlice";
import EmailSharingModalContent from "./EmailSharingModalContent";

const ConnectedEmailSharingModalContent = ({ controlId }) => {
    const control = useSelector((state) =>
        selectCmsControlById(controlId, state),
    );
    const {
        options: {
            additionalText = "",
            cancelButtonLabel = "Cancel",
            emailLabel = "Friend's Email",
            heading = "Email A Friend",
            linkFinePrint = "Link to campaign will be sent with message.",
            messageLabel = "Message",
            subjectLabel = "Subject",
            submitButtonLabel = "Send Email",
        },
    } = control;
    const emailSharingModalContentProps = {
        additionalText,
        cancelButtonLabel,
        emailLabel,
        heading,
        linkFinePrint,
        messageLabel,
        subjectLabel,
        submitButtonLabel,
        setAppEmailModalOpen,
    };

    return <EmailSharingModalContent {...emailSharingModalContentProps} />;
};

ConnectedEmailSharingModalContent.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedEmailSharingModalContent;
